<template>
  <article
    class="messages__chat__message"
    tabindex="-1"
    :class="[
      received
        ? 'messages__chat__message--received test-message_received'
        : 'messages__chat__message--sent test-message_sent'
    ]"
    :aria-label="label"
    @focus="onFocus"
  >
    <span class="sr_only">
      {{ author }}
    </span>
    <span>
      {{ message.body }}
    </span>
    <div class="messages__chat__message_date">
      {{ formatTimeForChat(message.inserted_at) }}
    </div>
  </article>
</template>

<script>
import { formatTimeForChat, toTimestamp } from './utils.js'

export default {
  name: 'ChatMessage',
  components: {},
  props: {
    message: { type: Object, required: true },
    partnerName: { type: String, required: true },
    onFocus: { type: Function, required: true }
  },
  computed: {
    received() {
      return this.message.type === 'received'
    },
    label() {
      return this.i18n.$gettext('Message')
    },
    author() {
      if (this.message.type === 'received') {
        return this.partnerName
      } else {
        return this.i18n.$gettext('You')
      }
    }
  },
  methods: {
    formatTimeForChat(datetime, opts) {
      return formatTimeForChat(toTimestamp(datetime), opts)
    }
  }
}
</script>
